module.exports = __webpack_public_path__ + "img/ipc_title_bac.20cdd49a.png";